/**
 * Floating ToC enhancements.
 */
"use strict";

(function($) {
  $(document.body).on('generatedToC', '.block-floating-toc', function(event) {
    // This script exists, the ToC has been generated, so add a class alerting
    // CSS that we have a ToC present on this page.
    $(document.body).addClass('has-toc');

    var $toc_block = $(this).find('.floating_toc');

    $('<h2 class="h5">On This Page</h2>').prependTo($toc_block);

    // Add a toggle button.
    var debounceTimer = null;
    var fnToCToggle = function(state) {
      $toc_block.toggleClass('toc-shown', state);
      // Fix animations so slide-out doesn't actually animate on first display.
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
      if (state) {
        $toc_block.addClass('toc-was-shown')
          .attr('tabindex', '0');
        setTimeout(function() { $toc_block.focus(); }, 100);
      }
      else {
        $toc_block.attr('tabindex', null);
        // Roughly match the ms delay here to the $duration value in SCSS.
        debounceTimer = setTimeout(function() { $toc_block.removeClass('toc-was-shown'); }, 350);
      }
      $toc_block.toggleClass('toc-hidden', !state);
      $toc_toggle
        .text(state ? 'Close Menu' : 'On This Page')
        .attr({
          "aria-expanded": !!state
        });
    };
    var fnToCButtonToggle = function(event) {
      // Register this modal, so it can be closed by other modals.
      if (!$toc_block.hasClass('toc-shown')) {
        lu_showModal('toc-menu', $toc_block, fnToCToggle, event);
      }
      else {
        lu_hideModal('toc-menu');
      }
      event.stopPropagation();
    };

    // Attach our open/close button.
    // Adding 'on-this-page' class to enable not hiding the button on mobile per Ken's request, see _floating_toc.scss line 78
    var $toc_toggle = $('<button id="toc-toggle" class="toc-toggle on-this-page" aria-label="On This Page navigation toggle">')
      .on('click', fnToCButtonToggle)
      .prependTo($toc_block.parents('.block-floating-toc'));
    var $toc_toggle_scnd = $('<button type="button" class="toc-toggle-secondary expanded-only">Close <span class="visually-hidden">On This Page menu</span> &nbsp; <img src="/themes/custom/lawrence_theme/img/icon-close.svg" alt="" width="23" height="23"></button>')
      .on('click', function() { lu_hideModal('toc-menu'); })
      .prependTo($toc_block);

    // Connect the button to the widget via ARIA attributes.
    $toc_block.find('.floating-toc-wrapper').attr({
      "aria-labelledby": "toc-toggle",
      "role": "region"
    });

    // Hook the new-third event, which signifies a change in scroll status.
    var breakpoint_bottom_menu_flip = 'medium';
    var has_ever_scrolled = false;
    $('#block-floatingtableofcontents')
      .on('scroll-move', function (event) {
        var show_toc = !!event.belowBottom || !lu_isBP(breakpoint_bottom_menu_flip);
        $(this).toggleClass('scrolled', show_toc);
        if (!show_toc) {
          // Ensure we close up any open drawers.
          setTimeout(function () {
            lu_hideModal('toc-menu');
          }, 0);
        }
        if (show_toc && !has_ever_scrolled) {
          $(this).addClass('has-ever-scrolled');
          has_ever_scrolled = true;
        }
      })
      // If (with a full-screen ToC panel) the user clicks a link, close the
      // ToC overlay so that they can see the results of their click.
      .on('click', 'a', function() {
        if (!lu_isBP(breakpoint_bottom_menu_flip)) {
          lu_hideModal('toc-menu');
        }
      });
    // $('<h2 class="h5">On This Page</h2>').prependTo($toc_block);
    // Set everything up for a hidden menu.
    fnToCToggle(false);
  });
})(jQuery);
